import React from "react";
import "./FreshProduct.css";
const FreshProduct = () => {
  return (
    <div className="freshproduct">
      <div className="freshproductimg">
        <img
          src="https://png.pngtree.com/thumb_back/fw800/background/20231015/pngtree-vibrant-lettuce-a-close-up-snapshot-of-fresh-salad-leaves-with-image_13679865.png"
          alt="IMG"
        />
      </div>
      <div className="freshproducttext">
            <h4>FRESH & NON-GMO PRODUCTS</h4>
      </div>
      <div className="freshproducttext1">
            <h4>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ex placeat beatae vero non .</h4>
      </div>
    </div>
  );
};

export default FreshProduct;
